// Language translation utility for E-Bike Damage Report App 
// Default language is German 
const translations={
de: {
// App.jsx 
title: 'Fahrrad Rückgabemeldung',
bookingId: 'Buchungs-ID',
step1: 'Fotos',
step2: 'Zustand',
nextStepButton: 'Weiter zur Zustandsbewertung',
loadingMessage: 'Meldung wird übertragen...',
errorMessage: 'Fehler beim Übertragen der Meldung. Bitte versuchen Sie es erneut.',
loading: 'Lädt...',

// PhotoUpload.jsx 
uploadTitle: 'Fotos hochladen',
uploadSubtitle: 'Lade Fotos vom Zustand des/der Bikes hoch',
openCamera: 'Kamera öffnen',
selectFiles: 'Dateien auswählen',
selectedPhotos: 'Ausgewählte Fotos',

// ConditionForm.jsx 
question: 'Frage',
of: 'von',
maintenanceExplanation: 'Damit der nächste Gast ein Top-Fahrrad erhält, brauchen wir deine Hilfe um eventuelle Wartungsarbeiten zu ermitteln.',
gears: 'Schaltung:',
brakes: 'Bremsen:',
otherIssues: 'Sonstige Mängel:',
additionalNotes: 'Zusätzliche Bemerkungen:',
gearsPlaceholder: 'Hakt, springt, Sonstiges',
brakesPlaceholder: 'Schleifgeräusche, schlechte Bremsleistung, quietschen, Sonstiges',
otherIssuesPlaceholder: 'Klappern/Knarzen, lockere Teile, Beleuchtung, Sonstiges',
additionalNotesPlaceholder: 'Optional: weitere Anmerkungen zum Bike oder zum Ausleihprozess',
perfect: 'Einwandfrei',
problems: 'Probleme',
back: 'Zurück',
next: 'Weiter',
submit: 'Meldung abschicken',
sending: 'Wird übertragen...',

// ThankYou.jsx 
thankYou: 'Vielen Dank!',
submissionSuccess: 'Deine Rückgabemeldung wurde erfolgreich übermittelt.',
chargeBike: 'Bei E-Bike: aufladen nicht vergessen',
chargeDescription: 'Bitte schließe das Ladegerät an,bevor Du den Raum verlässt.',
lockRoom: 'Raum abschließen',
lockDescription: 'Schließe die Tür und verriegele sie mit der Pfeiltaste auf dem Keypad außen.',

// Auth.jsx 
loginTitle: 'E-Bike Schadensmeldung',
loginSubtitle: 'Melden Sie sich an,um fortzufahren',
registerSubtitle: 'Erstellen Sie ein Konto',
emailLabel: 'E-Mail-Adresse',
emailPlaceholder: 'ihre.email@beispiel.de',
passwordLabel: 'Passwort',
loginButton: 'Anmelden',
registerButton: 'Registrieren',
noAccount: 'Noch kein Konto? Hier registrieren',
hasAccount: 'Bereits ein Konto? Hier anmelden',
authError: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
},
en: {
// App.jsx 
title: 'Bicycle Return Report',
bookingId: 'Booking ID',
step1: 'Photos',
step2: 'Condition',
nextStepButton: 'Continue to Condition Assessment',
loadingMessage: 'Submitting report...',
errorMessage: 'Error submitting the report. Please try again.',
loading: 'Loading...',

// PhotoUpload.jsx 
uploadTitle: 'Upload Photos',
uploadSubtitle: 'Upload photos showing the condition of the bike(s)',
openCamera: 'Open Camera',
selectFiles: 'Select Files',
selectedPhotos: 'Selected Photos',

// ConditionForm.jsx 
question: 'Question',
of: 'of',
maintenanceExplanation: 'To ensure the next guest receives a top-quality bicycle, we need your help to identify any potential maintenance work.',
gears: 'Gears:',
brakes: 'Brakes:',
otherIssues: 'Other Issues:',
additionalNotes: 'Additional Notes:',
gearsPlaceholder: 'Sticking,skipping,other issues',
brakesPlaceholder: 'Rubbing,poor braking performance,squeaking,other issues',
otherIssuesPlaceholder: 'Rattling,loose parts,lighting,other issues',
additionalNotesPlaceholder: 'Optional: additional comments about the bike or rental process',
perfect: 'Perfect',
problems: 'Problems',
back: 'Back',
next: 'Next',
submit: 'Submit Report',
sending: 'Sending...',

// ThankYou.jsx 
thankYou: 'Thank You!',
submissionSuccess: 'Your return report has been successfully submitted.',
chargeBike: 'For E-Bikes: Don\'t Forget to Charge',
chargeDescription: 'Please connect the charger before leaving the room.',
lockRoom: 'Lock the Room',
lockDescription: 'Close the door and lock it using the arrow key on the keypad outside.',

// Auth.jsx 
loginTitle: 'E-Bike Damage Report',
loginSubtitle: 'Sign in to continue',
registerSubtitle: 'Create an account',
emailLabel: 'Email Address',
emailPlaceholder: 'your.email@example.com',
passwordLabel: 'Password',
loginButton: 'Sign In',
registerButton: 'Register',
noAccount: 'No account yet? Register here',
hasAccount: 'Already have an account? Sign in here',
authError: 'An error occurred. Please try again.'
}
};

// Create a language utility to get translations
const createI18n=(defaultLang='de')=> {
let currentLang=defaultLang;

// Get translation for a key 
const t=(key)=> {
try {
const langData=translations[currentLang] || translations.de;
return langData[key] || translations.de[key] || key;
} catch (error) {
console.error(`Translation error for key: ${key}`,error);
return key;
}
};

// Get current language 
const getLanguage=()=> currentLang;

// Set language manually if needed 
const setLanguage=(lang)=> {
if (lang==='en' || lang==='de') {
currentLang=lang;
return true;
} 
return false;
};

return {
t,
getLanguage,
setLanguage
};
};

export default createI18n();

// ============================================================================
// Static UI strings for the dynamic return flow (booking-language aware)
// ----------------------------------------------------------------------------
// These are the static texts shown around the dynamic merchant content
// (loading states, error screens, navigation buttons, "close this window",
// etc.). They are looked up by the booking's language via the `t()` helper
// below, mirroring how merchant config text is resolved (`text[language]`).
//
// Supported languages: de, en, hu, fi, fr, es, it.
// English (`en`) is the safety fallback for any missing language or key.
// German (`de`) and Finnish (`fi`) use the INFORMAL address form (du / sinä).
//
// Parameterized strings (counts / pluralization) are stored as functions so
// each language owns its own grammar rules.
//
// NOTE: hu, fi, fr, es and it are intentionally left empty for now — every
// key falls back to English until the translated copy is dropped in. See
// docs/static-translations-worksheet.md for the keys to translate.
// ============================================================================

export const SUPPORTED_LANGUAGES = ['de', 'en', 'hu', 'fi', 'fr', 'es', 'it'];
export const FALLBACK_LANGUAGE = 'en';

const uiStrings = {
  de: {
    // App.jsx — loading / submitting
    loadingBooking: 'Lade Buchung...',
    submitting: 'Rückgabe wird eingereicht...',
    pleaseWait: 'Bitte warten...',

    // App.jsx — error screens (informal "du")
    errInvalidLinkTitle: 'Ungültiger Link',
    errInvalidLinkBody: 'Dieser Rückgabe-Link ist nicht gültig. Bitte verwende den Link aus deiner E-Mail oder SMS.',
    errExpiredTitle: 'Link abgelaufen',
    errExpiredBody: 'Dieser Rückgabe-Link ist abgelaufen. Bitte kontaktiere den Anbieter für einen neuen Link.',
    errNetworkTitle: 'Verbindungsproblem',
    errNetworkBody: 'Die Verbindung zum Server konnte nicht hergestellt werden. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
    errRevokedTitle: 'Link deaktiviert',
    errRevokedBody: 'Dieser Rückgabe-Link wurde deaktiviert. Bitte kontaktiere den Anbieter.',
    errGenericTitle: 'Fehler',
    errSubmitFailedTitle: 'Fehler beim Einreichen',
    errNoConfigTitle: 'Keine Konfiguration',
    errNoConfigBody: 'Für diesen Händler ist keine Rückgabekonfiguration vorhanden.',

    // App.jsx — submit error messages (informal "du")
    submitPhotosFailed: (n) => `${n} Foto${n > 1 ? 's' : ''} konnte${n > 1 ? 'n' : ''} nicht hochgeladen werden. Bitte versuche es erneut.`,
    submitNetworkFailed: 'Deine Rückgabe konnte aufgrund eines Verbindungsproblems nicht abgeschlossen werden. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
    submitError: 'Fehler beim Einreichen der Rückgabe',

    // Shared navigation / actions
    tryAgain: 'Erneut versuchen',
    back: 'Zurück',
    next: 'Weiter',
    skip: 'Überspringen',
    complete: 'Abschließen',

    // Section header fallbacks (used when the merchant has no configured header)
    questionsHeader: 'Fragen',
    photosHeader: 'Fotos',

    // DynamicThankYou.jsx
    thankYouTitle: 'Vielen Dank!',
    thankYouMessage: 'Deine Rückgabe wurde erfasst.',
    returnRecorded: 'Deine Rückgabe wurde erfolgreich erfasst.',
    closeWindow: 'Du kannst dieses Fenster jetzt schließen.',

    // DynamicPhotoUpload.jsx
    photosFailed: (n) => `${n} Foto${n > 1 ? 's' : ''} konnte${n > 1 ? 'n' : ''} nicht verarbeitet werden. Bitte versuche es mit einem anderen Foto erneut.`,
    photosFailedCanContinue: (n) => `${n} Foto${n > 1 ? 's' : ''} konnte${n > 1 ? 'n' : ''} auf diesem Gerät nicht verarbeitet werden. Du kannst ohne ${n > 1 ? 'sie' : 'es'} fortfahren.`,
    maxPhotosReached: (max) => `Maximal ${max} Fotos erlaubt`,
    minPhotosRequired: (min) => `Mindestens ${min} Foto${min > 1 ? 's' : ''} erforderlich`,
    photosRequired: 'Fotos sind erforderlich',
    photosLabel: 'Fotos',
    minAbbrev: 'mind.',
    camera: 'Kamera',
    gallery: 'Galerie',
    processingPhotos: 'Fotos werden verarbeitet...',
    noPhotos: 'Keine Fotos hochgeladen',

    // DynamicQuestionSet.jsx
    answerBeforeProceeding: 'Bitte beantworte die Frage, bevor du fortfährst',
    questionProgress: (cur, total) => `Frage ${cur} von ${total}`,

    // ItemLevelFlow.jsx
    itemProgress: (cur, total) => `Artikel ${cur} von ${total}`,
  },
  en: {
    // App.jsx — loading / submitting
    loadingBooking: 'Loading booking...',
    submitting: 'Submitting return...',
    pleaseWait: 'Please wait...',

    // App.jsx — error screens
    errInvalidLinkTitle: 'Invalid Link',
    errInvalidLinkBody: 'This return link is not valid. Please use the link from your email or SMS.',
    errExpiredTitle: 'Link Expired',
    errExpiredBody: 'This return link has expired. Please contact the provider for a new link.',
    errNetworkTitle: 'Connection Issue',
    errNetworkBody: 'We could not reach the server. Please check your internet connection and try again.',
    errRevokedTitle: 'Link Deactivated',
    errRevokedBody: 'This return link has been deactivated. Please contact the provider.',
    errGenericTitle: 'Error',
    errSubmitFailedTitle: 'Submission Failed',
    errNoConfigTitle: 'No Configuration',
    errNoConfigBody: 'No return configuration found for this merchant.',

    // App.jsx — submit error messages
    submitPhotosFailed: (n) => `${n} photo${n > 1 ? 's' : ''} could not be uploaded. Please try again.`,
    submitNetworkFailed: 'Your return could not be completed due to a connection issue. Please check your internet connection and try again.',
    submitError: 'Error submitting return',

    // Shared navigation / actions
    tryAgain: 'Try Again',
    back: 'Back',
    next: 'Next',
    skip: 'Skip',
    complete: 'Complete',

    // Section header fallbacks (used when the merchant has no configured header)
    questionsHeader: 'Questions',
    photosHeader: 'Photos',

    // DynamicThankYou.jsx
    thankYouTitle: 'Thank You!',
    thankYouMessage: 'Your return has been recorded.',
    returnRecorded: 'Your return has been successfully recorded.',
    closeWindow: 'You can now close this window.',

    // DynamicPhotoUpload.jsx
    photosFailed: (n) => `${n} photo${n > 1 ? 's' : ''} could not be processed. Please try a different photo.`,
    photosFailedCanContinue: (n) => `We couldn't process ${n} photo${n > 1 ? 's' : ''} on this device. You can continue without ${n > 1 ? 'them' : 'it'}.`,
    maxPhotosReached: (max) => `Maximum ${max} photos allowed`,
    minPhotosRequired: (min) => `At least ${min} photo${min > 1 ? 's' : ''} required`,
    photosRequired: 'Photos are required',
    photosLabel: 'photos',
    minAbbrev: 'min.',
    camera: 'Camera',
    gallery: 'Gallery',
    processingPhotos: 'Processing photos...',
    noPhotos: 'No photos uploaded',

    // DynamicQuestionSet.jsx
    answerBeforeProceeding: 'Please answer the question before proceeding',
    questionProgress: (cur, total) => `Question ${cur} of ${total}`,

    // ItemLevelFlow.jsx
    itemProgress: (cur, total) => `Item ${cur} of ${total}`,
  },

  // NOTE: hu/fi/fr/es/it below are first-draft translations and should be
  // proofread by a native speaker before release. de and fi use the informal
  // address form (du / sinä). Any key missing here falls back to English.
  hu: {
    loadingBooking: 'Foglalás betöltése...',
    submitting: 'Visszaküldés elküldése...',
    pleaseWait: 'Kérlek várj...',
    errInvalidLinkTitle: 'Érvénytelen link',
    errInvalidLinkBody: 'Ez a visszaküldési link nem érvényes. Kérjük, használd az e-mailben vagy SMS-ben kapott linket.',
    errExpiredTitle: 'A link lejárt',
    errExpiredBody: 'Ez a visszaküldési link lejárt. Kérjük, vedd fel a kapcsolatot a szolgáltatóval új linkért.',
    errNetworkTitle: 'Kapcsolódási hiba',
    errNetworkBody: 'Nem sikerült elérni a szervert. Ellenőrizd az internetkapcsolatodat, és próbáld újra.',
    errRevokedTitle: 'A link letiltva',
    errRevokedBody: 'Ezt a visszaküldési linket letiltották. Kérjük, vedd fel a kapcsolatot a szolgáltatóval.',
    errGenericTitle: 'Hiba',
    errSubmitFailedTitle: 'A küldés sikertelen',
    errNoConfigTitle: 'Nincs konfiguráció',
    errNoConfigBody: 'Ehhez a kereskedőhöz nincs visszaküldési konfiguráció.',
    submitPhotosFailed: (n) => `${n} fénykép feltöltése nem sikerült. Kérjük, próbáld újra.`,
    submitNetworkFailed: 'A visszaküldést kapcsolódási hiba miatt nem sikerült befejezni. Ellenőrizd az internetkapcsolatodat, és próbáld újra.',
    submitError: 'Hiba a visszaküldés elküldésekor',
    tryAgain: 'Próbáld újra',
    back: 'Vissza',
    next: 'Tovább',
    skip: 'Kihagyás',
    complete: 'Befejezés',
    questionsHeader: 'Kérdések',
    photosHeader: 'Fényképek',
    thankYouTitle: 'Köszönjük!',
    thankYouMessage: 'A visszaküldésedet rögzítettük.',
    returnRecorded: 'A visszaküldésedet sikeresen rögzítettük.',
    closeWindow: 'Most már bezárhatod ezt az ablakot.',
    photosFailed: (n) => `${n} fénykép feldolgozása nem sikerült. Próbálj meg egy másik fényképet.`,
    photosFailedCanContinue: (n) => `${n} fénykép feldolgozása nem sikerült ezen az eszközön. Folytathatod nélküle.`,
    maxPhotosReached: (max) => `Legfeljebb ${max} fénykép engedélyezett`,
    minPhotosRequired: (min) => `Legalább ${min} fénykép szükséges`,
    photosRequired: 'Fényképek szükségesek',
    photosLabel: 'fénykép',
    minAbbrev: 'min.',
    camera: 'Kamera',
    gallery: 'Galéria',
    processingPhotos: 'Fényképek feldolgozása...',
    noPhotos: 'Nincs feltöltött fénykép',
    answerBeforeProceeding: 'Kérjük, válaszolj a kérdésre a folytatás előtt',
    questionProgress: (cur, total) => `${cur}. kérdés / ${total}`,
    itemProgress: (cur, total) => `${cur}. tétel / ${total}`,
  },
  fi: {
    // informal (sinä-form)
    loadingBooking: 'Ladataan varausta...',
    submitting: 'Lähetetään palautusta...',
    pleaseWait: 'Odota hetki...',
    errInvalidLinkTitle: 'Virheellinen linkki',
    errInvalidLinkBody: 'Tämä palautuslinkki ei ole kelvollinen. Käytä sähköpostissasi tai tekstiviestissäsi olevaa linkkiä.',
    errExpiredTitle: 'Linkki on vanhentunut',
    errExpiredBody: 'Tämä palautuslinkki on vanhentunut. Ota yhteyttä palveluntarjoajaan saadaksesi uuden linkin.',
    errNetworkTitle: 'Yhteysongelma',
    errNetworkBody: 'Palvelimeen ei saatu yhteyttä. Tarkista internetyhteytesi ja yritä uudelleen.',
    errRevokedTitle: 'Linkki on poistettu käytöstä',
    errRevokedBody: 'Tämä palautuslinkki on poistettu käytöstä. Ota yhteyttä palveluntarjoajaan.',
    errGenericTitle: 'Virhe',
    errSubmitFailedTitle: 'Lähetys epäonnistui',
    errNoConfigTitle: 'Ei määritystä',
    errNoConfigBody: 'Tälle kauppiaalle ei ole määritetty palautusasetuksia.',
    submitPhotosFailed: (n) => `${n} kuva${n > 1 ? 'a' : ''} ei voitu ladata. Yritä uudelleen.`,
    submitNetworkFailed: 'Palautustasi ei voitu viedä loppuun yhteysongelman vuoksi. Tarkista internetyhteytesi ja yritä uudelleen.',
    submitError: 'Virhe palautuksen lähettämisessä',
    tryAgain: 'Yritä uudelleen',
    back: 'Takaisin',
    next: 'Seuraava',
    skip: 'Ohita',
    complete: 'Valmis',
    questionsHeader: 'Kysymykset',
    photosHeader: 'Kuvat',
    thankYouTitle: 'Kiitos!',
    thankYouMessage: 'Palautuksesi on kirjattu.',
    returnRecorded: 'Palautuksesi on kirjattu onnistuneesti.',
    closeWindow: 'Voit nyt sulkea tämän ikkunan.',
    photosFailed: (n) => `${n} kuva${n > 1 ? 'a' : ''} ei voitu käsitellä. Kokeile toista kuvaa.`,
    photosFailedCanContinue: (n) => `${n} kuva${n > 1 ? 'a' : ''} ei voitu käsitellä tällä laitteella. Voit jatkaa ilman ${n > 1 ? 'niitä' : 'sitä'}.`,
    maxPhotosReached: (max) => `Enintään ${max} kuvaa sallittu`,
    minPhotosRequired: (min) => `Vähintään ${min} kuva${min > 1 ? 'a' : ''} vaaditaan`,
    photosRequired: 'Kuvat vaaditaan',
    photosLabel: 'kuvaa',
    minAbbrev: 'väh.',
    camera: 'Kamera',
    gallery: 'Galleria',
    processingPhotos: 'Käsitellään kuvia...',
    noPhotos: 'Ei ladattuja kuvia',
    answerBeforeProceeding: 'Vastaa kysymykseen ennen jatkamista',
    questionProgress: (cur, total) => `Kysymys ${cur} / ${total}`,
    itemProgress: (cur, total) => `Tuote ${cur} / ${total}`,
  },
  fr: {
    loadingBooking: 'Chargement de la réservation...',
    submitting: 'Envoi du retour...',
    pleaseWait: 'Veuillez patienter...',
    errInvalidLinkTitle: 'Lien invalide',
    errInvalidLinkBody: "Ce lien de retour n'est pas valide. Veuillez utiliser le lien reçu par e-mail ou SMS.",
    errExpiredTitle: 'Lien expiré',
    errExpiredBody: 'Ce lien de retour a expiré. Veuillez contacter le prestataire pour obtenir un nouveau lien.',
    errNetworkTitle: 'Problème de connexion',
    errNetworkBody: 'Impossible de joindre le serveur. Veuillez vérifier votre connexion Internet et réessayer.',
    errRevokedTitle: 'Lien désactivé',
    errRevokedBody: 'Ce lien de retour a été désactivé. Veuillez contacter le prestataire.',
    errGenericTitle: 'Erreur',
    errSubmitFailedTitle: "Échec de l'envoi",
    errNoConfigTitle: 'Aucune configuration',
    errNoConfigBody: "Aucune configuration de retour n'a été trouvée pour ce marchand.",
    submitPhotosFailed: (n) => n > 1
      ? `${n} photos n'ont pas pu être téléchargées. Veuillez réessayer.`
      : `1 photo n'a pas pu être téléchargée. Veuillez réessayer.`,
    submitNetworkFailed: "Votre retour n'a pas pu être finalisé en raison d'un problème de connexion. Veuillez vérifier votre connexion Internet et réessayer.",
    submitError: "Erreur lors de l'envoi du retour",
    tryAgain: 'Réessayer',
    back: 'Retour',
    next: 'Suivant',
    skip: 'Ignorer',
    complete: 'Terminer',
    questionsHeader: 'Questions',
    photosHeader: 'Photos',
    thankYouTitle: 'Merci !',
    thankYouMessage: 'Votre retour a été enregistré.',
    returnRecorded: 'Votre retour a été enregistré avec succès.',
    closeWindow: 'Vous pouvez maintenant fermer cette fenêtre.',
    photosFailed: (n) => n > 1
      ? `${n} photos n'ont pas pu être traitées. Veuillez essayer une autre photo.`
      : `1 photo n'a pas pu être traitée. Veuillez essayer une autre photo.`,
    photosFailedCanContinue: (n) => n > 1
      ? `Nous n'avons pas pu traiter ${n} photos sur cet appareil. Vous pouvez continuer sans elles.`
      : `Nous n'avons pas pu traiter 1 photo sur cet appareil. Vous pouvez continuer sans elle.`,
    maxPhotosReached: (max) => `${max} photos maximum autorisées`,
    minPhotosRequired: (min) => min > 1 ? `Au moins ${min} photos requises` : 'Au moins 1 photo requise',
    photosRequired: 'Des photos sont requises',
    photosLabel: 'photos',
    minAbbrev: 'min.',
    camera: 'Appareil photo',
    gallery: 'Galerie',
    processingPhotos: 'Traitement des photos...',
    noPhotos: 'Aucune photo téléchargée',
    answerBeforeProceeding: 'Veuillez répondre à la question avant de continuer',
    questionProgress: (cur, total) => `Question ${cur} sur ${total}`,
    itemProgress: (cur, total) => `Article ${cur} sur ${total}`,
  },
  es: {
    loadingBooking: 'Cargando la reserva...',
    submitting: 'Enviando la devolución...',
    pleaseWait: 'Espera un momento...',
    errInvalidLinkTitle: 'Enlace no válido',
    errInvalidLinkBody: 'Este enlace de devolución no es válido. Utiliza el enlace de tu correo electrónico o SMS.',
    errExpiredTitle: 'Enlace caducado',
    errExpiredBody: 'Este enlace de devolución ha caducado. Ponte en contacto con el proveedor para obtener uno nuevo.',
    errNetworkTitle: 'Problema de conexión',
    errNetworkBody: 'No se pudo conectar con el servidor. Comprueba tu conexión a Internet e inténtalo de nuevo.',
    errRevokedTitle: 'Enlace desactivado',
    errRevokedBody: 'Este enlace de devolución ha sido desactivado. Ponte en contacto con el proveedor.',
    errGenericTitle: 'Error',
    errSubmitFailedTitle: 'Error al enviar',
    errNoConfigTitle: 'Sin configuración',
    errNoConfigBody: 'No se ha encontrado ninguna configuración de devolución para este comercio.',
    submitPhotosFailed: (n) => `No se ${n > 1 ? 'pudieron' : 'pudo'} subir ${n} foto${n > 1 ? 's' : ''}. Inténtalo de nuevo.`,
    submitNetworkFailed: 'No se pudo completar tu devolución debido a un problema de conexión. Comprueba tu conexión a Internet e inténtalo de nuevo.',
    submitError: 'Error al enviar la devolución',
    tryAgain: 'Intentar de nuevo',
    back: 'Atrás',
    next: 'Siguiente',
    skip: 'Omitir',
    complete: 'Finalizar',
    questionsHeader: 'Preguntas',
    photosHeader: 'Fotos',
    thankYouTitle: '¡Gracias!',
    thankYouMessage: 'Tu devolución ha sido registrada.',
    returnRecorded: 'Tu devolución se ha registrado correctamente.',
    closeWindow: 'Ya puedes cerrar esta ventana.',
    photosFailed: (n) => `No se ${n > 1 ? 'pudieron' : 'pudo'} procesar ${n} foto${n > 1 ? 's' : ''}. Prueba con otra foto.`,
    photosFailedCanContinue: (n) => `No se ${n > 1 ? 'pudieron' : 'pudo'} procesar ${n} foto${n > 1 ? 's' : ''} en este dispositivo. Puedes continuar sin ${n > 1 ? 'ellas' : 'ella'}.`,
    maxPhotosReached: (max) => `Máximo ${max} fotos permitidas`,
    minPhotosRequired: (min) => `Se ${min > 1 ? 'requieren' : 'requiere'} al menos ${min} foto${min > 1 ? 's' : ''}`,
    photosRequired: 'Se requieren fotos',
    photosLabel: 'fotos',
    minAbbrev: 'mín.',
    camera: 'Cámara',
    gallery: 'Galería',
    processingPhotos: 'Procesando fotos...',
    noPhotos: 'No hay fotos subidas',
    answerBeforeProceeding: 'Responde la pregunta antes de continuar',
    questionProgress: (cur, total) => `Pregunta ${cur} de ${total}`,
    itemProgress: (cur, total) => `Artículo ${cur} de ${total}`,
  },
  it: {
    loadingBooking: 'Caricamento della prenotazione...',
    submitting: 'Invio del reso...',
    pleaseWait: 'Attendi...',
    errInvalidLinkTitle: 'Link non valido',
    errInvalidLinkBody: 'Questo link per il reso non è valido. Usa il link ricevuto via e-mail o SMS.',
    errExpiredTitle: 'Link scaduto',
    errExpiredBody: 'Questo link per il reso è scaduto. Contatta il fornitore per ottenere un nuovo link.',
    errNetworkTitle: 'Problema di connessione',
    errNetworkBody: 'Impossibile raggiungere il server. Controlla la tua connessione a Internet e riprova.',
    errRevokedTitle: 'Link disattivato',
    errRevokedBody: 'Questo link per il reso è stato disattivato. Contatta il fornitore.',
    errGenericTitle: 'Errore',
    errSubmitFailedTitle: 'Invio non riuscito',
    errNoConfigTitle: 'Nessuna configurazione',
    errNoConfigBody: 'Nessuna configurazione di reso trovata per questo commerciante.',
    submitPhotosFailed: (n) => `Impossibile caricare ${n} foto. Riprova.`,
    submitNetworkFailed: 'Non è stato possibile completare il tuo reso a causa di un problema di connessione. Controlla la tua connessione a Internet e riprova.',
    submitError: "Errore durante l'invio del reso",
    tryAgain: 'Riprova',
    back: 'Indietro',
    next: 'Avanti',
    skip: 'Salta',
    complete: 'Completa',
    questionsHeader: 'Domande',
    photosHeader: 'Foto',
    thankYouTitle: 'Grazie!',
    thankYouMessage: 'Il tuo reso è stato registrato.',
    returnRecorded: 'Il tuo reso è stato registrato con successo.',
    closeWindow: 'Ora puoi chiudere questa finestra.',
    photosFailed: (n) => `Impossibile elaborare ${n} foto. Prova con un'altra foto.`,
    photosFailedCanContinue: (n) => `Impossibile elaborare ${n} foto su questo dispositivo. Puoi continuare senza.`,
    maxPhotosReached: (max) => `Massimo ${max} foto consentite`,
    minPhotosRequired: (min) => `Sono richieste almeno ${min} foto`,
    photosRequired: 'Le foto sono obbligatorie',
    photosLabel: 'foto',
    minAbbrev: 'min.',
    camera: 'Fotocamera',
    gallery: 'Galleria',
    processingPhotos: 'Elaborazione delle foto...',
    noPhotos: 'Nessuna foto caricata',
    answerBeforeProceeding: 'Rispondi alla domanda prima di continuare',
    questionProgress: (cur, total) => `Domanda ${cur} di ${total}`,
    itemProgress: (cur, total) => `Articolo ${cur} di ${total}`,
  },
};

// Normalize a language code to a supported base code:
// 'de-AT' -> 'de', 'EN' -> 'en'. Unknown codes fall back to English.
function normalizeLanguage(language) {
  if (!language || typeof language !== 'string') return FALLBACK_LANGUAGE;
  const base = language.toLowerCase().split(/[-_]/)[0];
  return uiStrings[base] ? base : FALLBACK_LANGUAGE;
}

const nonEmptyString = (value) => typeof value === 'string' && value.trim() !== '';

/**
 * Pick a merchant-configured text strictly in the requested language.
 * Returns '' when the language has no non-empty text, so callers can chain
 * their own fallback (typically a built-in t() string in the right language).
 *
 * @param {Object} textObj - config text object, e.g. { de: '...', en: '...' }
 * @param {string} language - booking language code (e.g. 'de', 'fr', 'de-AT')
 * @returns {string}
 */
export function pickConfigText(textObj, language) {
  if (!textObj || typeof textObj !== 'object') return '';
  const base = typeof language === 'string'
    ? language.toLowerCase().split(/[-_]/)[0]
    : '';
  const value = textObj[base];
  return nonEmptyString(value) ? value : '';
}

/**
 * Resolve a merchant-configured text with cross-language fallback:
 * requested language → English → first non-empty language.
 * For texts that have no built-in generic equivalent (question texts, option
 * labels, instructions), merchant text in the wrong language beats nothing.
 *
 * @param {Object} textObj - config text object, e.g. { de: '...', en: '...' }
 * @param {string} language - booking language code
 * @returns {string}
 */
export function resolveConfigText(textObj, language) {
  const exact = pickConfigText(textObj, language);
  if (exact) return exact;
  if (!textObj || typeof textObj !== 'object') return '';
  if (nonEmptyString(textObj.en)) return textObj.en;
  for (const value of Object.values(textObj)) {
    if (nonEmptyString(value)) return value;
  }
  return '';
}

/**
 * Translate a static UI string into the booking's language.
 *
 * @param {string} language - booking language code (e.g. 'de', 'fi', 'de-AT')
 * @param {string} key - translation key (see uiStrings above)
 * @param {...*} params - arguments for parameterized (function) strings
 * @returns {string}
 *
 * Resolution order: requested language → English fallback → the key itself.
 */
export function t(language, key, ...params) {
  const lang = normalizeLanguage(language);
  let value = uiStrings[lang][key];
  if (value === undefined) value = uiStrings[FALLBACK_LANGUAGE][key];
  if (value === undefined) return key;
  return typeof value === 'function' ? value(...params) : value;
}